import callAPiBase from './base';

const connectivityChipsApi = {
  list: ({ params }: { params: object }) => callAPiBase({
      endpoint: '/connectivityChipList',
      method: 'GET',
      useToken: true,
      title: 'Connectivity Chips - List',
      params,
    }),
  get: ({ params }: { params: object }) => callAPiBase({
      endpoint: '/connectivityChipGet',
      method: 'GET',
      useToken: true,
      title: 'Connectivity Chips - Get',
      params,
    }),
};

export { connectivityChipsApi };
export default connectivityChipsApi;
